import {
  RegistrationStatus,
  generateRegistrationStatus,
  validateField,
  FieldStatus,
} from '../viewmodels/RegistrationFormStatus';

export type updateAction = {
  field: string;
  value: string | null;
  data?: {
    password?: string;
    email?: string;
  };
};

export const registrationStatusReducer: (state: RegistrationStatus, action: updateAction) => RegistrationStatus = (
  state,
  action
) => {
  if (action === undefined) {
    return generateRegistrationStatus();
  }

  const outState = { ...state };
  let err: string | null = null;
  switch (action.field) {
    case 'email':
      outState.email = validateField('email', action.value as string) as FieldStatus<string>;
      return outState;
    case 'password':
      outState.password = validateField('password', action.value as string, action.data) as FieldStatus<string>;
      return outState;
    case 'confirmPassword':
      outState.confirmPassword = validateField(
        'confirmPassword',
        action.value as string,
        action.data!
      ) as FieldStatus<string>;
      return outState;

    case 'registrationForm':
      outState.email = validateField('email', state.email.value ?? null) as FieldStatus<string>;
      outState.password = validateField('password', state.password.value ?? null, action.data) as FieldStatus<string>;
      outState.confirmPassword = validateField('confirmPassword', state.confirmPassword.value ?? null, {
        password: state.password.value,
      }) as FieldStatus<string>;
      return outState;
    default:
      break;
  }
  return state;
};
